import ScrollTrigger from 'gsap/ScrollTrigger';
import { gsap } from 'gsap/gsap-core';
import { isAvifSupported } from '../lib/isAvifSupported';

export async function initWhatIs() {
  const parent = document.querySelector('.what-is');
  if (!parent) return;

  const model = parent.querySelector('.what-is__model');
  const inner = model.querySelector('.what-is__model-inner');

  gsap.fromTo(
    inner,
    { autoAlpha: 0 },
    {
      autoAlpha: 1,
      scrollTrigger: { trigger: model, start: 'top bottom-=5%' },
    },
  );

  if (!(await isAvifSupported())) return;

  ScrollTrigger.create({
    trigger: parent,
    start: 'top-=500 bottom',
    once: true,
    onEnter: async () => {
      const { init360 } = await import('./whatIs360');
      init360(model);
    },
  });
}
